import {typography} from 'material-ui/styles';
import * as colors from 'material-ui/styles/colors';

const styles = {
  navigation: {
    fontSize: 15,
    fontWeight: typography.fontWeightLight,
    color: colors.grey600,
    paddingBottom: 15,
    display: 'block'
  },
  title: {
    fontSize: 22,
    fontWeight: typography.fontWeightLight,
    marginBottom: 20,
    color: colors.grey600
  },
  paper: {
    padding: 30,
    minWidth: 1000,
    backgroundColor: colors.grey100
  },
  clear: {
    clear: 'both'
  },
  

  searchBoxContainer: {
    height: 'auto',
    margin: '20px 0px'
  },
  roumuContainer: {
    height: 'auto',
    margin: '20px 0px',
    padding: '20px',
    overflow: 'auto'
  },
  contentsPaper: {
    padding: 20,
    overflow: 'auto'
  },

  yosanPaper: {
    padding: 20,
    margin: 20,
  },
  yosanFormTitle: {
    fontSize: 19,
    color: colors.grey700,
    fontWeight: typography.fontWeightLight,
    marginBottom: 15
  },

  btn: {
    background: '#4f81e9',
    color: colors.white,
    padding: 7,
    borderRadius: 2,
    margin: 2,
    fontSize: 13
  },
  btnSpan: {
    marginLeft: 5
  },
  toggleDiv: {
    maxWidth: 300,
    marginTop: 40,
    marginBottom: 5
  },
  toggleLabel: {
    color: colors.grey400,
    fontWeight: 100
  },
  buttons: {
    marginTop: 30,
    float: 'right'
  },
  saveButton: {
    marginLeft: 5
  },
    checkRemember: {
    style: {
      float: 'left',
      maxWidth: 180,
      paddingTop: 5
    },
    labelStyle: {
      color: colors.grey500
    },
    iconStyle: {
      color: colors.grey500,
      borderColor: colors.grey500,
      fill: colors.grey500
    }
  },

    pageContents: {
        height: 'auto',
        margin: '20px 0px',
        padding: '20px'
    },
    yosanContents : {
      padding: 20,
    }

};

export default styles;



// WEBPACK FOOTER //
// ./src/styles.js